function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.00001 14.1429C8.88754 14.1425 8.77836 14.1064 8.68951 14.0402C5.85941 11.9277 3.9099 10.1086 2.54575 8.31392C0.804936 6.02048 0.407908 3.90309 1.36485 2.02043C2.04692 0.675663 4.00661 -0.424597 6.29716 0.215999C7.38926 0.519054 8.3421 1.16896 9.00001 2.05955C9.65791 1.16896 10.6107 0.519054 11.7029 0.215999C13.9883 -0.414817 15.9531 0.675663 16.6352 2.02043C17.5921 3.90309 17.1951 6.02048 15.4543 8.31392C14.0901 10.1086 12.1406 11.9277 9.3105 14.0402C9.22165 14.1064 9.11247 14.1425 9.00001 14.1429Z",
  fill: "#C4C4C4"
});

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.484a950c.svg";
export { ForwardRef as ReactComponent };